import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FileDown } from "lucide-react";
import { api } from "@/lib/api";
import { fmtEur } from "@/components/admin/ui-lite";
import { openAuthFile } from "@/components/location/AuthFile";
import { fmtDmy } from "@/components/location/DateTimeFields";

const label = (d) => (d.doc_type === "devis" ? (d.has_contract && d.is_signed ? "Devis + contrat de location signés" : d.has_contract ? "Devis + contrat de location" : "Devis") : d.is_deposit_invoice ? "Facture d'acompte" : "Facture");

export function RentalAccountingDocs({ year }) {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get(`/admin/accounting/rental-docs?year=${year}`).then((r) => setRows(r.data)).catch(() => setRows([])); }, [year]);
  if (!rows) return null;
  return (
    <section className="card-luxe p-5 md:p-6 mt-8" data-testid="accounting-rental-docs">
      <p className="eyebrow">Location de matériel</p>
      <h2 className="font-serif-luxe text-2xl mt-2">Devis, contrats et factures de location <span className="text-white/45 text-base">· {year}</span></h2>
      <p className="text-xs text-white/50 mt-1">Les factures et acomptes encaissés sont aussi comptés dans le récap ci-dessus et dans le livre des recettes.</p>
      {!rows.length && <p className="text-sm text-white/50 mt-4">Aucune location sur cette année.</p>}
      <div className="mt-4 space-y-4">
        {rows.map((r) => (
          <div key={r.rental_id} className="border border-white/10 p-4" data-testid={`acc-rental-${r.number}`}>
            <div className="flex flex-wrap items-baseline gap-3">
              <Link to={`/admin/location/dossiers/${r.rental_id}`} className="font-serif-luxe text-lg text-[#DCB457] underline underline-offset-2">{r.number}</Link>
              <span className="text-sm">{r.client_name}</span>
              <span className="text-xs text-white/45">{r.start_at ? fmtDmy(r.start_at) : ""}</span>
              <span className="ml-auto text-sm" data-testid={`acc-rental-encaisse-${r.number}`}>Encaissé : <b className="gold-text">{fmtEur(r.encaisse)}</b></span>
            </div>
            {!r.docs.length ? <p className="text-xs text-amber-300 mt-2">Aucun document de facturation.</p> : (
              <ul className="mt-2 text-sm divide-y divide-white/5">
                {r.docs.map((d) => (
                  <li key={d.id} className="flex flex-wrap items-center gap-3 py-2" data-testid={`acc-doc-${d.number}`}>
                    <span className="w-56 text-white/70">{label(d)}</span>
                    <Link to={`/admin/devis/${d.id}`} className="text-white underline-offset-2 hover:underline">{d.number}</Link>
                    <span className="text-xs text-white/45">{d.is_signed ? `signé le ${fmtDmy(d.signed_at)}` : d.paid_at ? `encaissé le ${fmtDmy(d.paid_at)}` : d.status}</span>
                    <span className="ml-auto">{fmtEur(d.total_ttc)}</span>
                    <button type="button" onClick={() => openAuthFile(`/admin/billing/${d.id}/pdf`)} className="text-[#DCB457]" aria-label="PDF" data-testid={`acc-doc-pdf-${d.number}`}><FileDown size={15} /></button>
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
